import { render, staticRenderFns } from "./LdConnectLwAccountBanner.vue?vue&type=template&id=363b166e&scoped=true"
import script from "./LdConnectLwAccountBanner.vue?vue&type=script&lang=js"
export * from "./LdConnectLwAccountBanner.vue?vue&type=script&lang=js"
import style0 from "./LdConnectLwAccountBanner.vue?vue&type=style&index=0&id=363b166e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b166e",
  null
  
)

export default component.exports